import { addMessages } from '@hana/i18n';

// Mee › Tổng quan: "Cách chấm" + Hỏi HANA về quy chế (board Mint-Mee, bổ sung 03/Nov).
addMessages('vi', {
  'meeask.methods': 'Cách chấm công',
  'meeask.methodsLb': 'Cách chấm',
  'meeask.ready': 'sẵn sàng',
  'meeask.gpsTip': 'VP Cộng Hòa · 38 m',
  'meeask.wifiTip': 'Đã bắt HANA-CH-5G',
  'meeask.qrTip': 'Quét mã động tại quầy lễ tân',
  'meeask.faceTip': 'Camera máy này · đã đăng ký khuôn mặt',
  'meeask.faceName': 'Khuôn mặt',
  'meeask.sheet': 'Chấm công bằng {m} chạy trên điện thoại · bản giả lập',
  'meeask.title': 'Hỏi HANA · quy chế & chính sách',
  'meeask.scope': 'Nội quy · chấm công · lương thưởng · nghỉ phép',
  'meeask.aria': 'Hỏi HANA về quy chế',
  'meeask.input': 'Câu hỏi cho Ask HANA',
  'meeask.ph': 'Hỏi về phép, đi muộn, tăng ca, bảo hiểm…',
  'meeask.ask': 'Hỏi',
  'meeask.src': 'Nguồn: {s}',
  'meeask.clear': 'Xoá',
  'meeask.q0': 'Tôi còn bao nhiêu ngày phép?',
  'meeask.a0': 'Bạn còn {l} ngày phép năm 2026 (đã trừ {p} ngày đang chờ duyệt). Phép năm chưa dùng hết được chuyển sang quý I năm sau.',
  'meeask.s0': 'Nội quy lao động 2026 · Điều 18 · số liệu HANA Mee',
  'meeask.k0': 'Tạo đơn nghỉ',
  'meeask.q1': 'Đi muộn bao nhiêu phút thì bị tính?',
  'meeask.a1': 'Vào sau đầu ca quá 5 phút là đi muộn; giờ đầu ca theo lịch làm việc công ty (WorkCalendar). Quá 2 lần trong tháng thì không nhận thưởng chuyên cần.',
  'meeask.s1': 'Quy chế chấm công · Điều 6 · Bảng lương › Thưởng chuyên cần',
  'meeask.k1': 'Xem chấm công',
  'meeask.q2': 'Làm thêm ngày nghỉ tính thế nào?',
  'meeask.a2': 'Giờ làm thêm chỉ tính khi đơn tăng ca được duyệt. Hệ số: ngày thường 150%, ngày nghỉ hằng tuần 200%, ngày lễ 300%.',
  'meeask.s2': 'Bộ luật Lao động 2019 · Điều 98 · Quy chế lương 2026 · Điều 9',
  'meeask.k2': 'Tạo đơn tăng ca',
  'meeask.q3': 'Quên chấm công thì làm sao?',
  'meeask.a3': 'Gửi đơn Giải trình công trong 2 ngày làm việc kể từ ngày quên chấm. Tối đa 3 lần mỗi tháng; quá số này cần TBP và HR cùng duyệt.',
  'meeask.s3': 'Quy chế chấm công · Điều 8',
  'meeask.k3': 'Tạo giải trình',
  'meeask.aOther': 'Ask HANA chỉ trả lời về lương, phiếu lương của chính bạn. Thông tin thu nhập của người khác không được chia sẻ.',
  'meeask.sOther': 'Quy chế bảo mật thông tin nhân sự · Điều 4',
  'meeask.kOther': 'Xem phiếu của tôi',
  'meeask.aNone': 'Em chưa tìm thấy mục phù hợp trong quy chế. Thử hỏi về phép, đi muộn, tăng ca hoặc quên chấm công.',
  'meeask.sNone': 'Sổ tay nhân viên HANA',
  'meeask.kNone': 'Xem chấm công',
});
addMessages('en', {
  'meeask.methods': 'Check-in method',
  'meeask.methodsLb': 'Method',
  'meeask.ready': 'ready',
  'meeask.faceName': 'Face',
  'meeask.title': 'Ask HANA · policies',
  'meeask.scope': 'Rules · attendance · pay · leave',
  'meeask.aria': 'Ask HANA about policies',
  'meeask.input': 'Question for Ask HANA',
  'meeask.ph': 'Ask about leave, lateness, overtime, insurance…',
  'meeask.ask': 'Ask',
  'meeask.src': 'Source: {s}',
  'meeask.clear': 'Clear',
});
